import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/member`;

export const getMemberDetail = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-member-detail${formData && formData.filter_type === 'binding' ? `/${formData.member_id}` : '/null'}`,
  body: formData
});

export const updateMemberNoteName = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update-member-note-name/${updateInfo.memberId}`,
  body: updateInfo
});

export const updateMemberDesc = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update-member-desc/${updateInfo.memberId}`,
  body: updateInfo
});
